export enum QueryKeys {
  History = 'history',
  GetRecordsCount = 'getRecordsCount',
  GetLastCoupleRecords = 'getLastCoupleRecords',
  GetRecordById = 'getRecordById',
}
